import React, {useState} from "react";
// import 'react-slideshow-image/dist/styles.css';
import { Container, Col, Row, Modal, Button } from "react-bootstrap";
import Slides from "./Slides"

export default function Presentation() {
    const imgCDNURL = process.env.REACT_APP_ABOUT203KLOAN_CDN_URL;
    const [showModal, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
    // const baseName = process.env.REACT_APP_BASENAME;

    // let basePath = baseName;
    // if (baseName === "/about203kloan") {
    //   basePath = basePath + "/";
    // }
    
    return (
      <div className="Presentation">
        <>
          <Container>
              <Row>
                <Col>
                {/* <a href={basePath + "slides"}>
                    <img src={imgCDNURL + "PresentationDesktop.webp"} className="presentationImg"/>
                </a>                 */}
                <img src={imgCDNURL + "PresentationDesktop.webp"} className="presentationImg" onClick={handleShow}/>
                <img src={imgCDNURL + "PresentationMobile.webp"} className="presentationImgMob" onClick={handleShow}/>
                        <Modal className="myModal modal-xl" show={showModal} onHide={handleClose}>
                          <Modal.Header closeButton>
                          </Modal.Header>
                          <Modal.Body>
                            <Slides />
                          </Modal.Body>
                        </Modal>
                </Col>
              </Row>
          </Container>
        </>
      </div>
    );
  }